import React from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import CommonStyles from './common_styles';

import { OPComponent, I18n } from '../components';

import { openPrivacy, openTerms, openPrivacyStatement } from './terms';

export default class PrivacyButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const textStyle = this.props.justButtons ? { fontSize: 14 } : null;
    return (
      <View style={{ width: '100%' }}>
        {!this.props.justButtons && (
          <Text style={styles.termsText}>{I18n.t('auth.byLoggingIn')}</Text>
        )}
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginTop: 10,
          }}
        >
          <Pressable style={styles.termsContainer} onPress={openPrivacy}>
            <Text style={[styles.termsButtonText, textStyle]}>{I18n.t('privacyPolicy')}</Text>
          </Pressable>
          <Pressable style={styles.termsContainer} onPress={openTerms}>
            <Text style={[styles.termsButtonText, textStyle]}>{I18n.t('termsOfUse')}</Text>
          </Pressable>
          <Pressable style={styles.termsContainer} onPress={openPrivacyStatement}>
            <Text style={[styles.termsButtonText, textStyle]}>{I18n.t('privacyStatement')}</Text>
          </Pressable>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({ ...CommonStyles });
